export default __webpack_public_path__ + "static/media/status-active.7e65720c.svg";